// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"111ec4de","339":"08d299c8","349":"4dd7c28d"}[chunkId] + ".chunk.js";
};